<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { HStack, VStack, Spacer } from "../layout";
  import { Button, Label, Hamburger, TextView } from "../widget";
  import ArticleForm from "./ArticleForm.svelte";
  import { send_bulk_email } from "../../mailing.js";
  import { deleteArticle, pin, publish } from "../../articles.js";
  import { getUsers } from "../../user.js";
  import { showOK, showError } from "../../dialog.js";

  export let isOwner = false;
  export let isEdit = false;
  export let article;
  export let wedding_guid;
  export let isOpened = false;
  export let submit;

  let cell;
  let current = null;
  let isEditArticle = false;
  let isHamburgerOpened = false;

  const dispatch = createEventDispatcher();

  const submitArticle = async (title, category, ranking, content, articleId) => {
    try {
      await submit(title, category, ranking, content, articleId);
      isEditArticle = false;
      article.content = JSON.stringify(content);
      article.title = title;
      article.category = category;
      article.ranking = ranking;
    } catch (e) {
      console.log(e);
      throw e;
    }
  };

  const cancel = () => {
    isEditArticle = false;
  };

  const delArticle = async () => {
    console.log("deleting article", article.id);
    isHamburgerOpened = false;
    await deleteArticle(wedding_guid, article.id);
    dispatch("refresh");
  };

  const editArticle = () => {
    isHamburgerOpened = false;
    isEditArticle = true;
  };

  const publishArticle = async () => {
    isHamburgerOpened = false;
    try {
      let published = article.published != "0";
      await publish(wedding_guid, article.id, !published);
      article.published = !published;
      article.published_date = new Date();
    } catch (e) {
      console.log(e);
    }
  };
  const pinArticle = async () => {
    isHamburgerOpened = false;
    try {
      let pinned = article.pinned != "0";
      await pin(wedding_guid, article.id, !pinned);
      article.pinned = !pinned;
    } catch (e) {
      console.log(e);
    }
  };

  const notifyArticle = async () => {
    isHamburgerOpened = false;
    try {
      let recipients = await getUsers(wedding_guid);
      recipients = recipients.data.map((e) => {
        e.user_id = e.id;
        e.id = undefined;
        e.article_id = article.id;
        e.email = e.login;
        return e;
      });
      console.log(recipients);
      await send_bulk_email(wedding_guid, "NB", undefined, recipients);
    } catch (e) {
      console.log(e);
      await showError(e);
    }
  };

  $: if (isOpened && cell) {
    cell.scrollIntoView();
  }
</script>

<article bind:this={cell}>
  <div class="title">
    <h1>{article.title}</h1>
    <Spacer />
    {#if isOwner && isEdit}
      <Hamburger bind:open={isHamburgerOpened} left={false}>
        <Button action={editArticle}>
          <Label text="Editer" icon="edit" h="24px" />
        </Button>
        <Button action={publishArticle}>
          <Label text="Publier" icon="file-export" h="24px" />
        </Button>
        <Button action={pinArticle}>
          <Label text="Epingler" icon="thumbtack" h="24px" />
        </Button>
        <Button action={notifyArticle}>
          <Label text="Notifier" icon="bell" h="24px" />
        </Button>
        <Button action={delArticle}>
          <Label text="Supprimer" icon="times-circle" h="24px" />
        </Button>
      </Hamburger>
    {/if}
  </div>

  {#if article.published != "0"}
    <span>Publié le {article.published_date}</span>
  {/if}
  {#if isOwner && isEdit}
    <span>Modifié le {article.modified_at}</span>
  {/if}

  {#if isOwner && isEdit && isEditArticle}
    <ArticleForm
      articleId={article.id}
      title={article.title}
      category={article.category}
      ranking={article.ranking}
      content={JSON.parse(article.content)}
      submit={submitArticle}
      {cancel}
      bind:show={isEditArticle} />
  {:else}
    <TextView content={JSON.parse(article.content)} />
  {/if}
</article>

<style>
  article {
    display: flex;
    flex-direction: column;
    padding-top: 5px;
    margin-bottom: 5px;
    border-bottom: 1px solid var(--secondary-light-color);
  }
  .title {
    display: flex;
    margin-top: 1em;
  }
  h1 {
    color: var(--primary-color);
    margin: 0;
  }
  span {
    color: #b8bdbd;
    font-size: small;
  }
  div {
    margin-top: 0.5em;
  }
</style>
